(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbBetslipUtilsContracts", [], factory);
	else if(typeof exports === 'object')
		exports["sbBetslipUtilsContracts"] = factory();
	else
		root["sbBetslipUtilsContracts"] = factory();
})(window, function() {
return 